import { useState } from 'react';

import {
  StyledSection,
  StyledTitle,
  StyledWrapper,
  StyledList,
  StyledListItem,
  StyledQuestion,
  StyledAnswer,
} from './Faq.styles';

export function FaqItem(props) {
  const [isOpen, setOpen] = useState(false);
  const manageOnKeyDown = (e) => {
    if (e.which === 32 || e.which === 13) setOpen(!isOpen);
  };

  return (
    <>
      <StyledQuestion
        aria-controls={props.id}
        aria-expanded={!!isOpen}
        dangerouslySetInnerHTML={{ __html: props.question }}
        isOpen={isOpen}
        role="button"
        tabIndex="0"
        onClick={() => setOpen(!isOpen)}
        onKeyDown={(e) => manageOnKeyDown(e)}
      />
      <StyledAnswer
        dangerouslySetInnerHTML={{ __html: props.answer }}
        id={props.id}
        isOpen={isOpen}
        role="region"
        tabindex="-1"
      />
    </>
  );
}

function Faq({ faqList }) {
  return (
    <StyledSection>
      <StyledWrapper>
        <StyledTitle>Domande frequenti</StyledTitle>
        <StyledList role="list">
          {faqList.map((item, i) => {
            return (
              <StyledListItem key={i}>
                <FaqItem id={`faq-answer-${i}`} question={item.question} answer={item.answer} />
              </StyledListItem>
            );
          })}
        </StyledList>
      </StyledWrapper>
    </StyledSection>
  );
}

export default Faq;
